// import {Transform, RAF} from 'f.component.util';
require('pixi.js');
import './vertical-zan.scss';
import './horizontal-zan.scss';
import ZanTpl from './zan.ejs';

console.log(PIXI);

class DianZan {
    constructor({ message, dianzan_config = {} }) {
        this.message = message;
        this.config = dianzan_config;
        this.init();
    }

    init() {
        console.log('config', config);
        this.state = true; // canvas状态
        this.timer = null;
        this.heartsContainer = []; // 管理容器

        this.initCallback = this.config.initCallback || function() {};
        this.speed = this.config.speed || 0.008;
        this.t = this.config.t || 0;
        this.originX = this.config.originX || 300;
        this.originY = this.config.originY || 500;
        this.heartX = this.config.heartX || 50;
        this.heartY = this.config.heartY || 20;
        this.speedLoop = this.config.speedLoop || 600;
        this.praiseType = (config.info && config.info.praiseType) || '2';

        this.initDom();
        this.initCanvas(this.config); // 初始化canvas
        this.initEvent();
        this.loadResources(this.setup); // 加载资源
        this.initCustomEvent();
    }

    initDom() {
        this.boxDom = $(ZanTpl());
        this.container = this.boxDom.find('#zan-canvas')[0];
        this.btnDom = this.boxDom.find('.btn');
        $('body').append(this.boxDom);
    }

    initCanvas(options) {
        let DPR = 1;
        let WIDTH = parseInt(document.documentElement.clientWidth / DPR);
        let HEIGHT = parseInt(document.documentElement.clientHeight / DPR);

        this.scale = parseFloat(WIDTH / 750);
        this.width = (options.width || 400) * this.scale;
        this.height = (options.height || 600) * this.scale;

        this.stage = new PIXI.Container();
        this.renderer = PIXI.autoDetectRenderer(this.width, this.height, {
            antialias: true,
            view: this.container,
            transparent: true
        });
    }

    initEvent() {
        // 点赞需求
        // this.loopZan();
        // this.btnDom.on('touchend', this.loopZanSpeed.bind(this))
        this.btnDom.on('touchend', this.zan.bind(this));
        this.btnDom.on('touchend', this.sendToMessageCenter.bind(this));
    }
    start(time, sta) {
        let _this = this;
        clearInterval(this.timer);
        this.timer = interval(function() {
            _this.initHeart('heart' + _this.random(0, 5), _this.genCoord());
        }, time);
    }

    stop() {
        clearInterval(this.timer);
    }
    loopZanSpeed() {
        let _this = this;
        this.speedLoop = 200;
        clearTimeout(this.loopZanSpeedTimer);
        this.loopZanSpeedTimer = setTimeout(function() {
            _this.speedLoop = 600;
        }, 2000);
    }
    loopZan() {
        // console.log('time--', this.speedLoop);
        let _this = this;
        clearTimeout(this.loopTimer);
        this.loopTimer = setTimeout(function() {
            _this.initHeart('heart' + _this.random(0, 5), _this.genCoord());
            _this.loopZan();
        }, this.speedLoop);
    }
    zan(fn) {
        this.initHeart('heart' + this.random(0, 5), this.genCoord());
        fn && typeof fn === 'function' && fn();
        return false;
    }

    initCustomEvent() {
        this.receiveFromMessageCenter();
    }

    receiveFromMessageCenter() {
        this.message.on('praise:zan', 201, this.zan.bind(this));
    }

    sendToMessageCenter() {
        this.message.send('praise', 101);
    }

    loadResources(callback) {
        let _this = this;
        // console.log(dataJson)
        // var texture = PIXI.Texture.fromImage(data.meta.image);
        let data = {};
        if (this.praiseType === '2') {
            if (document.body.classList.contains('wideScreen')) {
                data = require('./heartWideScreen.json');
            } else {
                data = require('./heart.json');
            }
        } else if (this.praiseType === '3') {
            data = require('./candle.json');
        }
        if (__urlParams.liveid == '131498') {
            data = require('./rat.json');
        }

        const baseTexture = new PIXI.BaseTexture.from(data.meta.image, null, 1);
        const spritesheet = new PIXI.Spritesheet(baseTexture, data);
        spritesheet.parse(function(textures) {
            // finished preparing spritesheet textures
            callback.bind(_this)();
        });
        // PIXI.loader
        //     .add(dataJson)
        //     // .on("progress", loadProgressHandler)
        //     .load(callback.bind(_this));
    }

    setup() {
        let _this = this;

        this.updateCanvas();
        this.initCallback();
    }

    genCoord() {
        let _originX = this.originX,
            _originY = this.originY,
            _heartX = this.heartX,
            _heartY = this.heartY;

        let _l = Math.random() > 0.5 ? 1 : -1;

        let start = { x: _originX, y: _originY };
        let c1 = {
            x: _originX + _l * this.random(_heartX, 2 * _heartX),
            y: ((_originY - _heartY) * this.random(5, 7)) / 10
        };
        let c2 = {
            x: _originX - _l * this.random(_heartX, 2 * _heartX),
            y: ((_originY - _heartY) * this.random(2, 4)) / 10
        };
        let end = { x: _originX + this.random(-_heartX, _heartX), y: _heartY };
        // console.log([start, c1, c2, end])
        return [start, c1, c2, end];
    }

    updateCanvas() {
        let _this = this;
        let _position = null;
        if (!this.state) {
            return;
        }

        for (let i = 0; i < this.heartsContainer.length; i++) {
            if (this.heartsContainer[i].t > 1) {
                this.heartsContainer[i].destroy();
                this.heartsContainer.splice(i, 1);
                i--;
            } else {
                _position = this.heartsContainer[i].bezierCurveTo(
                    this.heartsContainer[i].t
                );
                this.heartsContainer[i].position.x = _position[0] * this.scale;
                this.heartsContainer[i].position.y = _position[1] * this.scale;
                this.heartsContainer[i].t += this.speed;
                this.heartsContainer[i].alpha = 1 - this.heartsContainer[i].t;
            }
        }

        this.renderer.render(this.stage);

        requestAnimationFrame(this.updateCanvas.bind(this));
    }

    initHeart(name, data) {
        let _heart = new PIXI.Sprite(new PIXI.Texture.fromFrame(name + '.png'));
        _heart.t = 0;
        _heart.bezierCurveTo = this.bezierCurveTo(
            data[0],
            data[1],
            data[2],
            data[3]
        );
        _heart.anchor.set(0.5);
        _heart.scale.set(this.scale);
        // 放置在画面中间靠下的位置
        _heart.position.set(data[0].x, data[0].y);

        this.heartsContainer.push(_heart);
        this.stage.addChild(_heart);
    }

    bezierCurveTo(s, c1, c2, e, t) {
        let cx1 = 3 * (c1.x - s.x);
        let bx1 = 3 * (c2.x - c1.x) - cx1;
        let ax1 = e.x - s.x - cx1 - bx1;

        let cy1 = 3 * (c1.y - s.y);
        let by1 = 3 * (c2.y - c1.y) - cy1;
        let ay1 = e.y - s.y - cy1 - by1;

        return function(t) {
            let _x = ax1 * (t * t * t) + bx1 * (t * t) + cx1 * t + s.x;
            let _y = ay1 * (t * t * t) + by1 * (t * t) + cy1 * t + s.y;

            return [_x, _y];
        };
    }

    show() {
        this.btnDom.animate({ opacity: '1' });
        this.boxDom.show();
    }

    hide() {
        this.btnDom.animate({ opacity: '0' });
        this.boxDom.hide();
    }

    random(n, m) {
        return Math.floor(Math.random() * (m - n + 1) + n);
    }
}

function interval(func, wait) {
    var interv = function() {
        func.call(null);
        setTimeout(interv, wait);
    };
    setTimeout(interv, wait);
}

export default DianZan;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.dianzan.mobile/app/lib/zan.js